<template>
  <div class="upload-container">
    <a-upload
      class="upload"
      name="file"
      :showUploadList="false"
      withCredentials={true}
      action="https://ims.haiziwang.com/upload/file.do?appCode=hzw-b&bizCode=hzw-b-kos&_kos_login_source=hzwBus"
      :beforeUpload="beforeUpload"
      @change="uploadChangeHandler"
    >
      <div class="wrapper-inner">
        <div class="inner">
          <img src='https://hzwimspic-1251601690.image.myqcloud.com/6d746a90-8926-11ea-9c15-a97bbaf00d97_size_48x48'/>
          <div class="text">
            <span v-if="title">{{title}}</span>
            <slot v-else name="title"></slot>
          </div>
        </div>
      </div>
    </a-upload>
    <b-file-item
      v-for="(item, index) in value"
      :key="index"
      :img="item"
      :index="index"
      @close="itemCloseHandler"
    />
  </div>
</template>
<script>
  import {Icon, Upload} from 'ant-design-vue'
  import BFileItem from "./file-item";

  export default {
    name: 'bImgUpload',
    components: {
      BFileItem,
      [Upload.name]: Upload,
      [Icon.name]: Icon
    },
    props: {
      value: {
        type: Array
      },
      uploadType: {
        type: String,
        default: 'img'
      },
      title: {
        type: String,
        default: '点击上传'
      },
      showUploadList: {
        type: Boolean
      },
      max: {
        type: Number, // 最大上传个数
        default: 3
      }
    },
    data () {
      return {
        uploadList: this.value
      }
    },
    methods: {
      uploadChangeHandler ({ file }) {
        if (file.status === 'done' && file.response) {
          this.uploadList.push(file.response.content.downloadUrl)
          this.$nextTick(() => {
            this.$emit('change', this.uploadList)
          })
        }
      },
      itemCloseHandler (index) {
        // 按照下标删除
        this.uploadList.splice(index, 1)
        this.$nextTick(() => {
          this.$emit('change', this.uploadList)
        })
      },
      beforeUpload (file) {
        if (this.uploadList && this.uploadList.length >= this.max) {
          this.$message.error(`最多上传${this.max}张图片`)
          return false
        }
        const { type } = file
        // 可支持类型
        const validTypes = ['image/jpeg', 'image/png', 'image/jpg']
        const typeValid = validTypes.some(v => type === v)
        // 没有匹配成功
        if (!typeValid) {
          this.$message.error(`请上传正确的图片类型`)
        }
        return typeValid
      }
    }
  }
</script>
<style lang="scss" scoped>
  .upload-container {
    @include Flex();
    margin: -5px;
    .upload {
      margin: 5px;
      display: block;
      width: 100px;
      height: 100px;
      position: relative;
      border: 1px solid $text-gray-db;
      background: $bg-color-f7;

      &:hover {
        cursor: pointer;
      }
      .wrapper-inner {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        .inner {
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;

          img{
            width: 23.7px;
          }
          .text{
            font-size: 12px;
            color: $color-666;
          }
        }
      }

    }
  }
</style>
